import { serviceMaker } from "..";
import { IDDLFilter, IPagination } from "../../data/AppInterface";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";

interface IApplicationErrorPayload {
  device_name?: string;
  version?: string;
  browser_name?: string;
  browser_version?: string;
  os?: string;
  os_version?: string;
  url?: string;
  errorTime?: string;
  error_name?: string;
  error_message?: string;
  error_stack?: string;
  function_name?: string;
}

export const LOG_ERROR = (payload: IApplicationErrorPayload) =>
  serviceMaker(
    API_ENDPOINTS.error_handling.url,
    API_ENDPOINTS.error_handling.method,
    payload
  );

export const GET_PRESIGNED_URL = (url: string) =>
  serviceMaker(
    API_ENDPOINTS.get_presigned_url.url + `/${url}`,
    API_ENDPOINTS.get_presigned_url.method
  );

export const GLOBAL_DROP_DOWN = (payload: {
  entity: string;
  data_value: string;
  display_value: string;
  filters?: IDDLFilter[];
}) =>
  serviceMaker(
    API_ENDPOINTS.global_drop_down.url,
    API_ENDPOINTS.global_drop_down.method,
    payload
  );

export const UPLOAD_IMAGE = (data: FormData) =>
  serviceMaker(
    API_ENDPOINTS.upload_image.url,
    API_ENDPOINTS.upload_image.method,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
export const UPLOAD_VIDEO = (data: FormData) =>
  serviceMaker(
    API_ENDPOINTS.upload_video.url,
    API_ENDPOINTS.upload_video.method,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
export const UPLOAD_DOCUMENT = (data: FormData) =>
  serviceMaker(
    API_ENDPOINTS.upload_document.url,
    API_ENDPOINTS.upload_document.method,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

export const GET_ALL_AUDIT_LOG = (
  pagination: IPagination,
  recordId: string,
  type: string
) =>
  serviceMaker(
    API_ENDPOINTS.get_all_audit_log.url +
      `/${type}` +
      `/${recordId}` +
      `?perPageRows=${pagination.perPageRows}&currentPage=${pagination.currentPage}&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}`,
    API_ENDPOINTS.get_all_audit_log.method
  );
